<template>
  <div style="margin-bottom: 10px">
    <el-card
      class="box-card"
      style="margin-bottom: 3px"
      v-for="(activityItem, index) in data.activityList"
      :key="index"
    >
      <el-form-item
        label-width="70px"
        style="margin-bottom: 10px"
        label="key："
      >
        <el-input style="width: 80px" v-model="activityItem.key"></el-input>
        <el-button
          @click="remove(index)"
          style="float: right"
          icon="el-icon-delete"
          type="danger"
          circle
        >
        </el-button>
      </el-form-item>

      <el-card style="width: 600px; margin-bottom: 10px">
        <div slot="header" class="clearfix">
          <span>名称</span>
        </div>
        <base-desc
          @updated="updatedDataName"
          v-model="activityItem.name"
          :param="{ index: index }"
        ></base-desc>
      </el-card>

      <el-card style="width: 600px; margin-bottom: 10px">
        <div slot="header" class="clearfix">
          <span>排行榜排序字段描述</span>
        </div>
        <base-desc
          @updated="updatedDataLeaderboardSortFieldDesc"
          v-model="activityItem.leaderboardSortFieldDesc"
          :param="{ index: index }"
        ></base-desc>
      </el-card>

      <el-card style="width: 600px">
        <div slot="header" class="clearfix">
          <span>排行榜排名限制描述</span>
        </div>

        <el-card
          v-for="(rankLimitItem, limitIndex) in activityItem.rankLimitDesc"
          :key="limitIndex"
          style="margin-bottom: 2px; width: 550px"
        >
          <el-form-item
            label-width="60px"
            style="margin-bottom: 20px"
            label="排名："
          >
            <el-input
              type="nubmer"
              style="width: 80px"
              v-model.number="rankLimitItem.ranking"
              onkeyup="value=value.replace(/[^\d]/g, '')"
            ></el-input>
            <el-button
              @click="removeRankLimit(index, limitIndex)"
              style="float: right"
              icon="el-icon-delete"
              type="danger"
              circle
            >
            </el-button>
          </el-form-item>
          <el-form-item
            label-width="60px"
            style="margin-bottom: 10px"
            label="描述："
          >
            <base-desc
              @updated="updatedDataRankLimitDesc"
              v-model="rankLimitItem.desc"
              :param="{ index: index, limitIndex: limitIndex }"
            ></base-desc>
          </el-form-item>
        </el-card>
        <el-button
          style="margin-top: 10px"
          type="primary"
          icon="el-icon-plus"
          @click="addRankLimit(index)"
          >添加排名</el-button
        >
      </el-card>
    </el-card>
    <el-button
      v-if="global  || data.activityList.length == 0"
      size="medium"
      style="margin-top: 10px"
      plain
      type="primary"
      icon="el-icon-plus"
      @click="add()"
      >新增每周活动</el-button
    >
  </div>
</template>

<script>
import ShowItems from "./components/ShowItems";
import BaseDesc from "./biz-components/BaseDesc";
export default {
  data() {
    return {
      data: {
        activityList: [],
      },
    };
  },
  components: {
    ShowItems,
    BaseDesc,
  },

  watch: {
    data: {
      async handler() {
        await this.updatedParam();
      },
      deep: true,
    },
  },

  async created() {
    await this.loadConfig();
    if (this.parameter) {
      this.data = JSON.parse(this.parameter);
    }
  },

  props: {
    // 是否是跨服版本的每周活动（每周活动现在分为了既有的跨服版本和新的单服版本）
    global: {
      type: Boolean,
      default: false,
    },
    
    parameter: "",
  },

  methods: {
    async loadConfig() {},
    async add() {
      this.data.activityList.push({ rankLimitDesc: [] });
    },
    async remove(index) {
      try {
        // 弹确认框
        await this.$confirm(
          `确认删除key为：${this.data.activityList[index].key}的配置？`
        );
        this.data.activityList.splice(index, 1);

        await this.updatedParam();
      } catch (error) {}
    },

    async addRankLimit(index) {
      this.data.activityList[index].rankLimitDesc.push({});
    },
    async removeRankLimit(index, limitIndex) {
      try {
        // 弹确认框
        await this.$confirm(
          `确认删除key：${this.data.activityList[index].key}中
          排名：${this.data.activityList[index].rankLimitDesc[limitIndex].ranking}的配置？`
        );
        this.data.activityList.splice(index, 1);

        await this.updatedParam();
      } catch (error) {}
    },

    async updatedDataName(value, param) {
      this.data.activityList[param.index].name = value;
    },
    async updatedDataLeaderboardSortFieldDesc(value, param) {
      this.data.activityList[param.index].leaderboardSortFieldDesc = value;
    },
    async updatedDataRankLimitDesc(value, param) {
      this.data.activityList[param.index].rankLimitDesc[param.limitIndex].desc =
        value;
    },
    async updatedParam() {
      this.$emit("updated", JSON.stringify(this.data), async () => {
        return;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.link-button {
  padding-left: 5px;
  padding-right: 5px;
  color: rgb(37, 148, 240);

  cursor: pointer;
}

/deep/ .el-table__row td {
  padding: 0px 0;
}

.el-table .cell.el-tooltip {
  white-space: normal;
}
</style>